export const translations = {
  es: {
    logo: {
      slogan: 'INDUSTRIA EN MOVIMIENTO'
    },
    masterplan: {
      title: 'MASTERPLAN',
      subtitle: 'Superficie y cantidades generales.',
      totalArea: 'Superficie total',
      businessCenter: 'Centro de Negocios',
      sitePlanTitle: 'Plano del Sitio',
      clickInstruction: 'Haga clic en un lote disponible para consultar'
    },
    nav: {
      overview: 'Descripción',
      development: 'Desarrollo',
      location: 'Ubicación y Logística',
      amenities: 'Infraestructura',
      nearshoring: 'Nearshoring',
      contact: 'Contacto'
    },
    hero: {
      company: 'Hexaparks',
      tagline: 'Parques industriales de grado institucional para eficiencia logística, nearshoring y creación de valor a largo plazo.',
      location: 'El Sauz, Jalisco',
      cta: 'Solicitar información'
    },
    pillars: {
      discipline: {
        title: 'Disciplina de Capital',
        description: 'Desarrollo respaldado por capital institucional con enfoque en activos de calidad, cronogramas predecibles y creación de valor sostenible.'
      },
      location: {
        title: 'Posicionamiento Estratégico',
        description: 'Ubicaciones seleccionadas en corredores logísticos establecidos con conectividad comprobada a puertos, fronteras y centros de consumo.'
      },
      execution: {
        title: 'Ejecución Integrada',
        description: 'Control centralizado sobre diseño, construcción y operaciones, garantizando alineación entre especificaciones técnicas y requerimientos de inquilinos.'
      }
    },
    development: {
      title: 'Enfoque de Desarrollo',
      text1: 'Hexaparks desarrolla activos industriales con estándares institucionales: diseño estructural robusto, sistemas dimensionados para operación continua y flexibilidad para adaptación a múltiples usos industriales.',
      text2: 'El parque en Jalisco representa nuestra primera ubicación operativa. La plataforma está diseñada para expandirse a múltiples parques y tipologías—logística, manufactura ligera, build-to-suit—conforme se identifiquen corredores estratégicos adicionales.'
    },
    siteplan: {
      title: 'Ubicación y Acceso Logístico',
      subtitle: 'Circuito Metropolitano Sur km 21, Tala, Jalisco',
      corridors: 'Corredores Industriales',
      corridor1: 'Circuito Metropolitano Sur',
      corridor2: 'Carretera Guadalajara-Ameca',
      corridor3: 'Macrolibramiento de Guadalajara',
      proximity: 'Proximidad a Infraestructura',
      airport: 'Aeropuerto Internacional de Guadalajara',
      airportDist: '45 km',
      port: 'Puerto de Manzanillo',
      portDist: '280 km',
      downtown: 'Centro Guadalajara',
      downtownDist: '35 km',
      elSalto: 'Zona Industrial El Salto',
      elSaltoDist: '15 km'
    },
    amenities: {
      title: 'Infraestructura y Amenidades',
      subtitle: 'Instalaciones diseñadas para operación industrial continua',
      categories: {
        businessCenter: {
          title: 'Business Center',
          description: 'Instalaciones administrativas y operacionales centralizadas que soportan coordinación de inquilinos, gestión del parque, y funciones de supervisión in-situ. Incluye salas de reuniones equipadas, espacios de trabajo compartido para personal administrativo, área de recepción con atención profesional, servicios de correspondencia y paquetería, coordinación de servicios de mantenimiento, y soporte administrativo para nuevos inquilinos durante su período de instalación.'
        },
        security: {
          title: 'Seguridad y Control de Acceso',
          description: 'Sistema integral de seguridad perimetral con vigilancia 24/7, control de acceso vehicular y peatonal mediante credenciales, sistema de CCTV con monitoreo en tiempo real y respaldo de grabaciones, casetas de acceso con personal capacitado, coordinación directa con autoridades locales, protocolos de emergencia establecidos y simulacros periódicos, y sistema de comunicación interna para respuesta rápida.'
        },
        infrastructure: {
          title: 'Infraestructura Robusta',
          description: 'Sistemas de alta capacidad incluyendo suministro eléctrico trifásico con capacidad de expansión, red de agua potable con almacenamiento y presión constante, sistema de drenaje pluvial dimensionado para eventos extremos, tratamiento de aguas residuales industriales conforme a normativa, y corredores de servicios planificados para expansión futura.'
        },
        utilities: {
          title: 'Servicios Públicos y Energía',
          description: 'Infraestructura eléctrica de media tensión con transformadores dedicados por nave, preparación para sistemas de respaldo y generación, subestación eléctrica propia con capacidad de crecimiento, medición independiente por usuario, y provisiones para instalación de energía solar o sistemas de cogeneración.'
        },
        connectivity: {
          title: 'Conectividad y Fibra Óptica',
          description: 'Infraestructura de telecomunicaciones carrier-neutral con acceso a múltiples proveedores, ductos de fibra óptica redundantes, puntos de conexión preparados en cada nave, capacidad para enlaces dedicados de alta velocidad, y soporte para sistemas de automatización industrial y IoT.'
        },
        truckAccess: {
          title: 'Acceso y Maniobras de Camiones',
          description: 'Vialidades internas diseñadas para tráfico pesado con pavimento de concreto hidráulico de alta resistencia, radios de giro certificados para tractocamiones full y doble remolque, señalización clara de rutas y restricciones, separación de flujos de tráfico ligero y pesado, y áreas de espera para vehículos en proceso de carga.'
        },
        loading: {
          title: 'Andenes y Especificaciones de Carga',
          description: 'Andenes tipo dock con niveladores hidráulicos y sellos perimetrales, acceso a nivel de piso para montacargas y patines, alturas de andén compatibles con estándares de transporte mexicano y norteamericano, iluminación de área de trabajo, y protecciones contra impacto en columnas y andenes.'
        },
        parking: {
          title: 'Estacionamiento',
          description: 'Áreas de estacionamiento segregadas por tipo de usuario: zona de empleados con capacidad según ratios industriales estándar, estacionamiento de visitantes con acceso controlado, patio de maniobras y estacionamiento de remolques, área designada para vehículos de carga en espera, y estacionamiento para bicicletas fomentando movilidad sustentable.'
        },
        emergency: {
          title: 'Emergencia y Cumplimiento',
          description: 'Accesos diseñados para vehículos de emergencia sin obstrucciones, sistema contra incendio con red de hidrantes y conexiones para bomberos, naves con sistemas de supresión automática (sprinklers), extintores y señalización conforme a NOM, brigadas de emergencia capacitadas, y cumplimiento de normativas de Protección Civil y Secretaría del Trabajo.'
        },
        sustainability: {
          title: 'Sustentabilidad y Estándares Ambientales',
          description: 'Diseño considerando eficiencia energética con iluminación LED y aprovechamiento de luz natural, áreas verdes y permeables para recarga de acuíferos, gestión de residuos con separación y disposición controlada, preparación para certificaciones ambientales (LEED, EDGE), y monitoreo de indicadores de consumo energético e hídrico.'
        }
      }
    },
    nearshoring: {
      title: 'Contexto de Nearshoring',
      subtitle: 'Posicionamiento en la reconfiguración de cadenas de suministro de Norteamérica',
      context: 'La reconfiguración de cadenas de suministro globales ha posicionado a México como destino prioritario para manufactura orientada a Norteamérica. El tratado T-MEC proporciona el marco regulatorio, mientras que la proximidad geográfica reduce tiempos de entrega y costos logísticos comparado con proveedores asiáticos.',
      points: [
        'Marco T-MEC: comercio libre de aranceles entre México, EUA y Canadá',
        'Reducción de tiempos de entrega vs. origen asiático',
        'Mitigación de riesgos geopolíticos mediante diversificación',
        'Conectividad establecida a puertos del Pacífico y fronteras terrestres',
        'Fuerza laboral técnica competitiva en costos',
        'Zona horaria alineada con mercados finales norteamericanos'
      ],
      positioning: 'Hexaparks desarrolla infraestructura industrial en corredores estratégicos para capturar demanda derivada de esta reconfiguración. El enfoque actual es Jalisco; la plataforma contempla expansión a ubicaciones adicionales conforme madure la demanda de nearshoring.'
    },
    standards: {
      title: 'Capacidades de Desarrollo',
      design: 'Especificaciones Técnicas',
      designDesc: 'Naves con alturas libres de 10-12 metros, pisos de concreto con capacidad de carga de 3-5 ton/m², estructura de acero con claros de 24+ metros, y flexibilidad para subdivisión o expansión.',
      construction: 'Build-to-Suit',
      constructionDesc: 'Diseño y construcción personalizada según especificaciones de inquilinos ancla, con cronogramas coordinados y entrega llave en mano.',
      delivery: 'Desarrollo Especulativo',
      deliveryDesc: 'Naves estándar disponibles para arrendamiento inmediato, con flexibilidad para adaptaciones menores según requerimientos específicos.',
      scalability: 'Desarrollo por Fases',
      scalabilityDesc: 'Infraestructura maestra diseñada para crecimiento ordenado, con servicios escalables y reserva de tierra para futuras expansiones.'
    },
    finalCta: {
      title: 'Asociarse con Hexaparks',
      subtitle: 'Para consultas sobre disponibilidad, especificaciones técnicas o programar visita al sitio.',
      button: 'Contactar'
    },
    contact: {
      title: 'Contacto',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      company: 'Empresa',
      type: 'Tipo de consulta',
      typeInvestor: 'Inversionista institucional',
      typeTenant: 'Inquilino potencial',
      typePartner: 'Socio estratégico',
      typeOther: 'Otro',
      message: 'Mensaje',
      submit: 'Enviar',
      success: 'Mensaje enviado correctamente. Nos pondremos en contacto pronto.',
      error: 'Error al enviar. Por favor intente nuevamente.'
    },
    footer: {
      company: 'Hexaparks',
      tagline: 'Desarrollo industrial institucional en México',
      address: 'Circuito Metropolitano Sur km 21, Tala, Jalisco',
      email: 'sales@hexaparks.com',
      legal: 'Aviso legal',
      privacy: 'Privacidad',
      social: 'Síguenos',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      twitter: 'X'
    }
  },
  en: {
    logo: {
      slogan: 'INDUSTRY IN MOTION'
    },
    masterplan: {
      title: 'MASTERPLAN',
      subtitle: 'Surface area and general quantities.',
      totalArea: 'Total area',
      businessCenter: 'Business Center',
      sitePlanTitle: 'Site Plan',
      clickInstruction: 'Click on an available lot to inquire'
    },
    nav: {
      overview: 'Overview',
      development: 'Development',
      location: 'Location & Logistics',
      amenities: 'Amenities',
      nearshoring: 'Nearshoring',
      contact: 'Contact'
    },
    hero: {
      company: 'Hexaparks',
      tagline: 'Institutional-grade industrial parks for logistics efficiency, nearshoring, and long-term value creation.',
      location: 'El Sauz, Jalisco',
      cta: 'Request Information'
    },
    pillars: {
      discipline: {
        title: 'Capital Discipline',
        description: 'Development backed by institutional capital focused on quality assets, predictable timelines, and sustainable value creation.'
      },
      location: {
        title: 'Strategic Positioning',
        description: 'Locations selected in established logistics corridors with proven connectivity to ports, borders, and consumption centers.'
      },
      execution: {
        title: 'Integrated Execution',
        description: 'Centralized control over design, construction, and operations, ensuring alignment between technical specifications and tenant requirements.'
      }
    },
    development: {
      title: 'Development Approach',
      text1: 'Hexaparks develops industrial assets to institutional standards: robust structural design, systems sized for continuous operation, and flexibility for adaptation to multiple industrial uses.',
      text2: 'The Jalisco park represents our first operational location. The platform is designed to expand to multiple parks and typologies—logistics, light manufacturing, build-to-suit—as additional strategic corridors are identified.'
    },
    siteplan: {
      title: 'Location & Logistics Access',
      subtitle: 'Circuito Metropolitano Sur km 21, Tala, Jalisco',
      corridors: 'Industrial Corridors',
      corridor1: 'Circuito Metropolitano Sur',
      corridor2: 'Guadalajara-Ameca Highway',
      corridor3: 'Guadalajara Outer Ring Road',
      proximity: 'Infrastructure Proximity',
      airport: 'Guadalajara International Airport',
      airportDist: '45 km',
      port: 'Port of Manzanillo',
      portDist: '280 km',
      downtown: 'Guadalajara CBD',
      downtownDist: '35 km',
      elSalto: 'El Salto Industrial Zone',
      elSaltoDist: '15 km'
    },
    amenities: {
      title: 'Infrastructure & Amenities',
      subtitle: 'Facilities designed for continuous industrial operation',
      categories: {
        businessCenter: {
          title: 'Business Center',
          description: 'Centralized administrative and operational facilities supporting tenant coordination, park management, and on-site oversight functions. Includes equipped meeting rooms, shared workspace for administrative staff, professional reception area, mail and package services, maintenance coordination, and administrative support for new tenants during their setup period.'
        },
        security: {
          title: 'Security & Access Control',
          description: 'Comprehensive perimeter security system with 24/7 surveillance, credential-based vehicular and pedestrian access control, CCTV with real-time monitoring and recording backup, staffed access booths with trained personnel, direct coordination with local authorities, established emergency protocols with periodic drills, and internal communication system for rapid response.'
        },
        infrastructure: {
          title: 'Robust Infrastructure',
          description: 'High-capacity systems including three-phase electrical supply with expansion capacity, potable water network with storage and constant pressure, stormwater drainage sized for extreme events, industrial wastewater treatment per regulations, and planned utility corridors for future expansion.'
        },
        utilities: {
          title: 'Utilities & Power',
          description: 'Medium-voltage electrical infrastructure with dedicated transformers per building, preparation for backup and generation systems, on-site electrical substation with growth capacity, independent metering per user, and provisions for solar installation or cogeneration systems.'
        },
        connectivity: {
          title: 'Connectivity & Fiber',
          description: 'Carrier-neutral telecommunications infrastructure with multi-provider access, redundant fiber optic ducts, prepared connection points at each building, capacity for dedicated high-speed links, and support for industrial automation and IoT systems.'
        },
        truckAccess: {
          title: 'Truck Access & Maneuvering',
          description: 'Internal roadways designed for heavy traffic with high-strength hydraulic concrete pavement, certified turning radii for full and double trailer trucks, clear route and restriction signage, separation of light and heavy traffic flows, and waiting areas for vehicles in loading process.'
        },
        loading: {
          title: 'Loading Docks & Specs',
          description: 'Dock-height platforms with hydraulic levelers and perimeter seals, grade-level access for forklifts and pallet jacks, dock heights compatible with Mexican and North American transport standards, work area lighting, and impact protection on columns and docks.'
        },
        parking: {
          title: 'Parking',
          description: 'Parking areas segregated by user type: employee zone with capacity per standard industrial ratios, visitor parking with controlled access, trailer maneuvering yard and parking, designated area for waiting cargo vehicles, and bicycle parking promoting sustainable mobility.'
        },
        emergency: {
          title: 'Emergency & Compliance',
          description: 'Unobstructed access designed for emergency vehicles, fire protection system with hydrant network and firefighter connections, buildings with automatic suppression systems (sprinklers), extinguishers and signage per NOM standards, trained emergency brigades, and compliance with Civil Protection and Labor Ministry regulations.'
        },
        sustainability: {
          title: 'Sustainability & Environmental Standards',
          description: 'Design considering energy efficiency with LED lighting and natural light utilization, green and permeable areas for aquifer recharge, waste management with separation and controlled disposal, preparation for environmental certifications (LEED, EDGE), and monitoring of energy and water consumption indicators.'
        }
      }
    },
    nearshoring: {
      title: 'Nearshoring Context',
      subtitle: 'Strategic positioning in North American supply chain realignment',
      context: 'Global supply chain reconfiguration has positioned Mexico as a priority destination for manufacturing oriented to North America. The USMCA framework provides the regulatory structure, while geographic proximity reduces lead times and logistics costs compared to Asian suppliers.',
      points: [
        'USMCA framework: tariff-free trade between Mexico, US, and Canada',
        'Reduced lead times vs. Asian origin',
        'Geopolitical risk mitigation through diversification',
        'Established connectivity to Pacific ports and land borders',
        'Cost-competitive technical workforce',
        'Time zone aligned with North American end markets'
      ],
      positioning: 'Hexaparks develops industrial infrastructure in strategic corridors to capture demand derived from this reconfiguration. Current focus is Jalisco; the platform contemplates expansion to additional locations as nearshoring demand matures.'
    },
    standards: {
      title: 'Development Capabilities',
      design: 'Technical Specifications',
      designDesc: 'Buildings with 10-12 meter clear heights, concrete floors with 3-5 ton/m² load capacity, steel structure with 24+ meter clear spans, and flexibility for subdivision or expansion.',
      construction: 'Build-to-Suit',
      constructionDesc: 'Custom design and construction per anchor tenant specifications, with coordinated timelines and turnkey delivery.',
      delivery: 'Speculative Development',
      deliveryDesc: 'Standard buildings available for immediate lease, with flexibility for minor adaptations per specific requirements.',
      scalability: 'Phased Development',
      scalabilityDesc: 'Master infrastructure designed for orderly growth, with scalable utilities and land reserve for future expansions.'
    },
    finalCta: {
      title: 'Partner with Hexaparks',
      subtitle: 'For inquiries regarding availability, technical specifications, or to schedule a site visit.',
      button: 'Contact'
    },
    contact: {
      title: 'Contact',
      name: 'Full name',
      email: 'Email address',
      phone: 'Phone',
      company: 'Company',
      type: 'Inquiry type',
      typeInvestor: 'Institutional investor',
      typeTenant: 'Potential tenant',
      typePartner: 'Strategic partner',
      typeOther: 'Other',
      message: 'Message',
      submit: 'Submit',
      success: 'Message sent successfully. We will be in touch soon.',
      error: 'Error sending message. Please try again.'
    },
    footer: {
      company: 'Hexaparks',
      tagline: 'Institutional industrial development in Mexico',
      address: 'Circuito Metropolitano Sur km 21, Tala, Jalisco',
      email: 'sales@hexaparks.com',
      legal: 'Legal',
      privacy: 'Privacy',
      social: 'Follow',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      twitter: 'X'
    }
  },
  zh: {
    logo: {
      slogan: '工业在行动'
    },
    masterplan: {
      title: '总体规划',
      subtitle: '面积和总体数量。',
      totalArea: '总面积',
      businessCenter: '商务中心',
      sitePlanTitle: '场地规划',
      clickInstruction: '点击可用地块进行咨询'
    },
    nav: {
      overview: '概述',
      development: '开发',
      location: '位置与物流',
      amenities: '设施',
      nearshoring: '近岸外包',
      contact: '联系'
    },
    hero: {
      company: 'Hexaparks',
      tagline: '机构级工业园区，专为物流效率、近岸外包和长期价值创造而开发。',
      location: 'El Sauz, 哈利斯科',
      cta: '索取信息'
    },
    pillars: {
      discipline: {
        title: '资本纪律',
        description: '由机构资本支持的开发，专注于优质资产、可预测的时间表和可持续的价值创造。'
      },
      location: {
        title: '战略定位',
        description: '在已建立的物流走廊中选择位置，与港口、边境和消费中心有经验证的连通性。'
      },
      execution: {
        title: '综合执行',
        description: '对设计、施工和运营的集中控制，确保技术规格与租户要求之间的一致性。'
      }
    },
    development: {
      title: '开发方法',
      text1: 'Hexaparks按照机构标准开发工业资产：稳健的结构设计、为持续运营设计的系统，以及适应多种工业用途的灵活性。',
      text2: '哈利斯科园区是我们第一个运营位置。该平台旨在扩展到多个园区和类型——物流、轻型制造、定制建造——随着识别出更多战略走廊。'
    },
    siteplan: {
      title: '位置与物流通道',
      subtitle: 'Circuito Metropolitano Sur km 21, Tala, Jalisco',
      corridors: '工业走廊',
      corridor1: 'Circuito Metropolitano Sur',
      corridor2: '瓜达拉哈拉-阿梅卡高速公路',
      corridor3: '瓜达拉哈拉外环路',
      proximity: '基础设施邻近性',
      airport: '瓜达拉哈拉国际机场',
      airportDist: '45 公里',
      port: '曼萨尼约港',
      portDist: '280 公里',
      downtown: '瓜达拉哈拉CBD',
      downtownDist: '35 公里',
      elSalto: 'El Salto工业区',
      elSaltoDist: '15 公里'
    },
    amenities: {
      title: '基础设施与设施',
      subtitle: '为持续工业运营而设计的设施',
      categories: {
        businessCenter: {
          title: '商务中心',
          description: '集中的行政和运营设施，支持租户协调、园区管理和现场监督功能。包括配备齐全的会议室、行政人员共享工作空间、专业接待区、邮件和包裹服务、维护协调，以及新租户在安装期间的行政支持。'
        },
        security: {
          title: '安全与访问控制',
          description: '全面的周边安全系统，24/7监控，基于凭证的车辆和行人访问控制，带实时监控和录像备份的闭路电视，配备训练有素人员的门禁岗亭，与地方当局直接协调，定期演练的既定应急协议，以及快速响应的内部通信系统。'
        },
        infrastructure: {
          title: '强大的基础设施',
          description: '大容量系统，包括可扩展的三相电力供应、带存储和恒压的饮用水网络、为极端事件设计的雨水排放、符合法规的工业废水处理，以及为未来扩展规划的公用设施走廊。'
        },
        utilities: {
          title: '公用设施与电力',
          description: '中压电气基础设施，每栋建筑配有专用变压器，为备用和发电系统做好准备，具有增长能力的现场电力变电站，每用户独立计量，以及太阳能安装或热电联产系统的预留。'
        },
        connectivity: {
          title: '连接与光纤',
          description: '运营商中立的电信基础设施，可访问多个提供商，冗余光纤管道，每栋建筑准备好的连接点，专用高速链接能力，以及工业自动化和物联网系统支持。'
        },
        truckAccess: {
          title: '卡车通道与操纵',
          description: '为重型交通设计的内部道路，采用高强度液压混凝土路面，全拖车和双拖车认证的转弯半径，清晰的路线和限制标识，轻重交通流分离，以及装载过程中等待车辆的区域。'
        },
        loading: {
          title: '装卸码头与规格',
          description: '带液压调平器和周边密封的码头高度平台，叉车和托盘车的地面装卸通道，与墨西哥和北美运输标准兼容的码头高度，工作区照明，以及柱子和码头的防撞保护。'
        },
        parking: {
          title: '停车场',
          description: '按用户类型隔离的停车区域：按标准工业比率配置的员工区域，受控访问的访客停车场，拖车操纵场和停车场，等待货运车辆的指定区域，以及促进可持续出行的自行车停车场。'
        },
        emergency: {
          title: '紧急情况与合规',
          description: '为紧急车辆设计的无障碍通道，带消防栓网络和消防员连接的消防系统，配备自动灭火系统（喷水器）的建筑，符合NOM标准的灭火器和标识，训练有素的应急队伍，以及符合民防和劳工部法规。'
        },
        sustainability: {
          title: '可持续性与环境标准',
          description: '考虑能效的设计，采用LED照明和自然采光利用，绿色和渗透区域用于地下水补给，带分类和受控处置的废物管理，为环境认证（LEED、EDGE）做好准备，以及能源和水消耗指标的监测。'
        }
      }
    },
    nearshoring: {
      title: '近岸外包背景',
      subtitle: '北美供应链重组中的战略定位',
      context: '全球供应链重组已将墨西哥定位为面向北美制造业的优先目的地。USMCA框架提供监管结构，而地理邻近性降低了与亚洲供应商相比的交货时间和物流成本。',
      points: [
        'USMCA框架：墨西哥、美国和加拿大之间的免关税贸易',
        '相比亚洲来源缩短交货时间',
        '通过多元化减轻地缘政治风险',
        '与太平洋港口和陆地边境的既定连通性',
        '具有成本竞争力的技术劳动力',
        '与北美终端市场一致的时区'
      ],
      positioning: 'Hexaparks在战略走廊开发工业基础设施，以捕捉由此重组产生的需求。当前重点是哈利斯科；该平台考虑随着近岸外包需求的成熟扩展到其他地点。'
    },
    standards: {
      title: '开发能力',
      design: '技术规格',
      designDesc: '净高10-12米的建筑，承载能力3-5吨/平方米的混凝土地板，净跨24米以上的钢结构，以及可分割或扩展的灵活性。',
      construction: '定制建造',
      constructionDesc: '根据主力租户规格定制设计和建造，协调时间表和交钥匙交付。',
      delivery: '投机开发',
      deliveryDesc: '可立即租赁的标准建筑，可根据具体要求进行小幅调整。',
      scalability: '分阶段开发',
      scalabilityDesc: '为有序增长设计的主基础设施，可扩展的公用设施和为未来扩展预留的土地。'
    },
    finalCta: {
      title: '与 Hexaparks 合作',
      subtitle: '有关可用性、技术规格或安排现场参观的咨询。',
      button: '联系'
    },
    contact: {
      title: '联系方式',
      name: '全名',
      email: '电子邮件',
      phone: '电话',
      company: '公司',
      type: '咨询类型',
      typeInvestor: '机构投资者',
      typeTenant: '潜在租户',
      typePartner: '战略合作伙伴',
      typeOther: '其他',
      message: '信息',
      submit: '提交',
      success: '消息发送成功。我们会尽快联系您。',
      error: '发送错误。请重试。'
    },
    footer: {
      company: 'Hexaparks',
      tagline: '墨西哥机构工业开发',
      address: 'Circuito Metropolitano Sur km 21, Tala, Jalisco',
      email: 'sales@hexaparks.com',
      legal: '法律',
      privacy: '隐私',
      social: '关注',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      twitter: 'X'
    }
  }
};
